
  import {Component, Ref, Vue} from "vue-property-decorator";
  import {ActivityDto, AuditUserLogStatus, AuditUserLogType, ReimbursementDto} from "@/api/appService";
  import api from '@/api/index';
  import AuditTabPane from "@/views/audits/components/AuditTabPane.vue";
  import ReimbursementDetail from "@/views/pays/components/detail-reimbursement.vue";

  @Component({name:'AuditTabOfReimbursement',components:{
      ReimbursementDetail,
      AuditTabPane
    }})
  export default class AuditTabOfReimbursement extends Vue{

    currentDetailId:number = 0;

    getHostType(){
      return AuditUserLogType.Reimbursement;
    }

    fetchData(){
      return api.reimbursement.getMyAll;
    }

    auditPass(){
      return api.reimbursement.audit;
    }

    handleCountChange(value:number){
      this.$emit('count-changed',value);
    }

    handleOpenDetail(item:any){
      this.currentDetailId = item.id as number;
      (this.$refs.reimbursementDetail as any).show = true;
    }

  }
